import React from "react";
import AgentInterface from "../../components/Agent/AgentInterface";
function Agent({ user, inTools }) {
  return <AgentInterface user={user} inTools={inTools} />;
}

export default Agent;
